import { PublicApiService } from './app/services/api/public-api.service'
import './assets/scss/style.scss'

const api = PublicApiService.getInstance()
api.createUMDPublicObject()
